<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  mounted() {
    this.renderChart(
      {
        
        labels: [
          "16/08/2021",
        ],
        datasets: [
      {
        label: "Manhour planned",
        type: "horizontalBar",
        data: [8],
        backgroundColor: "rgba(20, 153, 242,.5)",

        borderWidth: 3
      },
      {
        label: "Manhour actual",
        type: "horizontalBar",
        data: [6],
        backgroundColor: "rgba(247, 15, 15,.5)",
        borderWidth: 3
      }
  ]
      
},
      { 
      responsive: true, 
      maintainAspectRatio: false, 

       legend: {
            position: "bottom"
          },
  	   
  	      scales: {
          	yAxes: [{
              ticks: {
                    // min: 0,
                    // max: 10,
                    // beginAtZero: true,
                    // labelString: 'Manhour Average'
                      }
                    }],
            xAxes: [{
              ticks: {
                    min: 0,
                    max: 10,
                    beginAtZero: true,
                    labelString: 'Manhour Average'
                      }
                    }],
                  }    
        
      }
      
    );
  }
};
</script>